import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import { BankIDInputMeta, CorporateNameInputMeta } from "@Shared/containers/form/commonMeta";

export interface IHistory3DSecureStatusUpdateFormMeta {
    bankId: FormInputMeta;
    bank: FormInputMeta;
    agency: FormInputMeta;
    customer: FormInputMeta;
    pan: FormInputMeta;

    schema: any;
}

const history3DSecureStatusUpdateFormMeta = {} as IHistory3DSecureStatusUpdateFormMeta;

history3DSecureStatusUpdateFormMeta.bankId = {...BankIDInputMeta, name: 'bankId'};

history3DSecureStatusUpdateFormMeta.bank = {
    ...CorporateNameInputMeta,
    name: "bank",
    label: "Banque",
};

history3DSecureStatusUpdateFormMeta.agency = {
    name: "agency",
    type: "select",
    label: "Agence",
    placeholder: "",
    validation: yup.string(),
};

history3DSecureStatusUpdateFormMeta.customer = {
    name: "customer",
    type: "select",
    label: "Client",
    placeholder: "",
    validation: yup.string(),
};

history3DSecureStatusUpdateFormMeta.pan = {
    name: "pan",
    type: "select",
    label: "PAN",
    placeholder: "",
    validation: yup.string(),
};


history3DSecureStatusUpdateFormMeta.schema = yup.object().shape(getValidationSchema(history3DSecureStatusUpdateFormMeta));

export default history3DSecureStatusUpdateFormMeta;